import { ChangeEmitter } from '@/application/ChangeEmitter';
import { ImageField } from '@/domain/image/ImageField';
import type { I2DEngine } from '@/application/ports/I2DEngine';
import type { IEntityRepository } from '@/application/ports/IEntityRepository';
import type { TImagePropertyPatch } from '@/domain/image/TImagePropertyPatch';

class ImageController {
    constructor(
        private readonly _engine: I2DEngine,
        private readonly _repository: IEntityRepository,
        private readonly _changeEmitter: ChangeEmitter,
    ) {}

    // Awaits the engine before announcing the change: replacing an image source
    // loads it asynchronously, so emitting first had subscribers read a canvas
    // that still showed the previous image — the side thumbnail stayed on the
    // pre-crop version with no later event to correct it.
    async applyImageProperty(entityId: string, patch: TImagePropertyPatch): Promise<void> {
        const entity = this._repository.get(entityId);
        if (!(entity instanceof ImageField)) {
            console.error(`ImageController.applyImageProperty: entity ${entityId} is not an image field`);
            return;
        }
        entity.applyProperty(patch);
        await this._engine.applyImageProperty(entityId, patch);
        this._repository.update(entity);
        this._changeEmitter.emit();
    }
}

export { ImageController };
